module.exports = __webpack_public_path__ + "static/img/ic-tec-logo-spark.fccb2e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ic-tec-logo-spark.png
// module id = oJMO
// module chunks = 1